import { PAGE_DEFAULT } from "types/actions/page"

export const setPage = data => ({
  type: PAGE_DEFAULT,
  data
})
